"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var emitterSubscription_1 = __importDefault(require("./subscriptions/emitterSubscription"));
var suscriberRegistry_1 = __importDefault(require("./suscriberRegistry"));
var Emitter = (function () {
    function Emitter() {
        this._subscriber = new suscriberRegistry_1.default();
        this._currentSubscription = null;
    }
    Emitter.prototype.addListener = function (eventType, listener, context) {
        return this._subscriber.addSubscription(eventType, new emitterSubscription_1.default(this._subscriber, listener, context));
    };
    Emitter.prototype.removeCurrentListener = function () {
        if (this._currentSubscription)
            this._subscriber.removeSubscription(this._currentSubscription);
    };
    Emitter.prototype.removeAllListeners = function (eventType) {
        this._subscriber.removeAllSubscriptions(eventType);
    };
    Emitter.prototype.fire = function (eventType, args) {
        var _this = this;
        var subscriptions = this._subscriber.getSubscriptionsOfType(eventType);
        if (subscriptions) {
            subscriptions.forEach(function (subscription) {
                if (subscription) {
                    subscription.listener.apply(_this, args);
                    _this._currentSubscription = subscription;
                }
            });
        }
    };
    return Emitter;
}());
exports.Emitter = Emitter;
//# sourceMappingURL=emitter.js.map